import React from 'react';

const LoadingSpinner = ({ size = 'md', color = 'blue', fullScreen = false, text }) => {
  const sizeClasses = {
    sm: 'h-4 w-4 border-2',
    md: 'h-8 w-8 border-2',
    lg: 'h-12 w-12 border-b-2'
  };

  const colorClasses = {
    blue: 'border-blue-600 border-t-transparent',
    gray: 'border-gray-300 border-t-gray-600',
    white: 'border-white border-t-transparent'
  };

  const spinner = (
    <div className={`animate-spin rounded-full ${sizeClasses[size]} ${colorClasses[color]}`}></div>
  );

  if (fullScreen) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        {spinner}
        {text && <p className="mt-4 text-gray-600">{text}</p>}
      </div>
    );
  }

  if (text) {
    return (
      <div className="flex flex-col items-center justify-center p-4">
        {spinner}
        <p className="mt-2 text-sm text-gray-600">{text}</p>
      </div>
    );
  }

  return spinner;
};

export default LoadingSpinner;
